<template>

    <v-row justify="center" align="center" class="ma-0 pa-0" style="height:100% !important">
      <v-card elevation="5"  width="500"   class="p-20 dialogcolor">
        <v-row justify="space-around" class="mt-2 mb-1">
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-avatar size="150">
                <v-img :src="profilePicture" @error="setAvatar()" :alt="name">
                </v-img>
                <v-fade-transition>
                  <v-overlay
                    opacity="0.65"
                    v-if="hover"
                    absolute>
                    <v-btn @click="show=true" text>
                      Change Picture
                    </v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-avatar>
            </template>
          </v-hover>
        </v-row>
        <v-form v-model="valid" id="profile-edit" class="mx-2">
          <v-text-field
          ref="nameref"
            class="select-field py-3 customInputRound"
            label="Name"
            clearable
            v-model="name"
            required
            :rules="nameRules"
            validate-on-blur
            solo
            outlined
          >
          </v-text-field>
        </v-form>
        <v-row justify="space-around" class="align-center mb-2 mx-2">
          <v-btn
            class="save-btn"
            text
            @click="$store.dispatch('resetPassword', user.email)">
            Reset Password
          </v-btn>
          <v-btn
            class="save-btn"
            text
            @click="save()">
            Save
          </v-btn>
          <v-btn
            class="cancel-btn"
            style="height: 50px !important"
            text
            @click="$router.push('/api_key')">
            Cancel
          </v-btn>
        </v-row>
        <image-upload
          field="picture"
          @crop-success="cropSuccess"
          v-model="show"
          :width="200"
          :height="200"
          langType="en"
          img-format="png">
        </image-upload>
      </v-card>
    </v-row>

</template>

<script>
import { mapGetters } from 'vuex'
import avatarUrlMixin from '../mixins/avatarUrlMixin'
import imageUpload from 'vue-image-crop-upload'

export default {
  name: 'ProfileEditor',
  mixins: [avatarUrlMixin],
  components: {
    imageUpload
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted () {
    this.$nextTick(() => this.$refs.nameref.focus())
    this.name = this.user.name
    this.profilePicture = this.user.picture
  },
  data () {
    return {
      valid: false,
      show: false,
      name: '',
      nameRules: [
        v => !!v || 'Name is required'
      ],
      profilePicture: ''
    }
  },
  methods: {
    setAvatar () {
      this.profilePicture = this.getAvatarUrl(null, this.user.name, true)
    },
    save () {
      // avatar_url field is removed when a profile_pic is uploaded
      const userData = {
        entity_id: this.user.entity_id,
        user_id: this.user.user_id,
        affiliate_id: this.user.affiliate_id,
        email: this.user.email,
        email_verified: this.user.email_verified,
        nickname: this.user.nickname,
        blocked: false,
        name: this.name,
        picture: this.profilePicture,
        eula_accepted: true,
        tour_complete: !!this.user?.tour_complete
      }
      this.$store.dispatch('updateProfile', { data: userData, shouldReload: true })
    },
    cropSuccess (imgDataUrl) {
      this.profilePicture = imgDataUrl
      this.save()
    }
  }

}
</script>
<style lang="scss" scoped>
.dialogcolor{
  border-radius: 25px !important;
  border: 2px solid $primary-color !important;
}
</style>
